module.exports = __webpack_public_path__ + "media/images/bhima_welcome-9462b1748070fed5d49b3dd30e1f8246.png";